import React from "react";

// Automatically import all SVGs as React components
const iconModules = import.meta.glob("@/assets/role-icons/*.svg", {
  eager: true,
  query: "?react",
}) as Record<string, { default?: React.FC<any> } | React.FC<any>>;

const ROLE_ICON_MAP: Record<string, string> = {
  catering_delivery_driver: "catering_delivery_driver",
  barista: "barista",
  cafe_manager: "cafe_manager",
  sandwich_artist: "sandwich_artist",
  food_prep_worker: "food_prep_worker",
  food_safety_specialist: "food_safety_specialist",
  event_set_up_crew: "event_set_up_crew",
  front_of_house_staff: "security_personnel",
  delivery_driver: "security_personnel",
  security_personnel: "security_personnel",
  bakers_assistant: "baker",
  baker: "baker",
  cocktail_server: "cocktail_server",
  pub_manager: "pub_manager",
  pastry_chef: "pastry_chef",
  cake_decorator: "cake_decorator",
  catering_chef: "catering_chef",
  event_planner: "event_planner",
  banquet_server: "banquet_server",
  catering_coordinator: "multi_role",
  catering_assistant: "multi_role",
  assistant_manager: "multi_role",
  general_manager: "multi_role",
  server: "multi_role",
  kitchen_assistant: "multi_role",
  maintenance_worker: "multi_role",
  cleaner: "multi_role",
  janitor: "multi_role",
  marketing_specialist: "multi_role",
  customer_service_representative: "multi_role",
  waitstaff_trainer: "multi_role",
  catering_driver: "multi_role",
  stagiaire_shadow_foh: "multi_role",
  stagiaire_shadow_boh: "multi_role",
};

function getRoleIconValue(value: string): string {
  return ROLE_ICON_MAP[value] || value;
}

function getIcon(value: string) {
  const keys = Object.keys(iconModules);
  let found = keys.find((key) => key.includes(value));
  if (!found) {
    found = keys.find((key) => key.includes("default"));
  }
  if (!found) return null;
  const mod = iconModules[found];
  // Some modules may be default exports, some may be the component itself
  return ((mod as { default?: React.FC<any> }).default ?? mod) as React.FC<any>;
}

export function RoleIcon({
  value,
  width = 30,
  height = 30,
  variant = "gradient",
  ...props
}: {
  value: string;
  width?: number;
  height?: number;
  variant?: "gradient" | "white";
} & React.SVGProps<SVGSVGElement>) {
  const Icon = getIcon(getRoleIconValue(value));
  if (!Icon) return null;
  // For 'white' variant, set color to white (SVGs use their own gradient definitions)
  // For 'gradient', render as-is (SVGs have their own gradient definitions)
  const extraProps = variant === "white" ? { color: "white" } : {};
  return (
    <Icon
      {...props}
      {...extraProps}
      width={width}
      height={height}
    />
  );
}
